const getters = {
  all: state => state.all,
  find: state => state.order,
  listStatus: state => state.listStatus,
  count: state => state.count,
  isLoading: state => state.isLoading,
  isOrderLoading: state => state.isOrderLoading,
  materials: state => state.materials,
  excessMaterials: state => state.excessMaterials,
  isExcessMaterialLoading: state => state.isExcessMaterialLoading,
  isMaterialLoading: state => state.isMaterialLoading,
  lr: state => state.lr,
  isLrLoading: state => state.isLrLoading,
  currentDepot: state => state.currentDepot,
  isPaginating: state => state.isPaginating,
  hyperTrack: state => state.hyperTrack,
  latestUpdated: state => state.latestUpdated,
  isUploading: state => state.isUploading,
  filter: state => state.filter,
  filterTermTags: state => state.filter_term_tags,
  filterSearchTerm: state => state.filter_search_term,
  isEmptyPaginate: state => state.isEmptyPaginate,
  materialHeaders: state => state.materialHeaders,
  isGlobalFilter: state => state.isGlobalFilter,
  globalSearchQ: state => state.globalSearchQ,
  // grn: state => state.grn,
  grnLoading: state => state.grnLoading,
  grnDetails: state => state.grnDetails,
  getSdlcCategorization: state => state.getSdlcCategorization,
  createSdlcCategorization: state => state.createSdlcCategorization,
  trackingList: state => state.trackingList,
  consignmentTrackingList: state => state.consignmentTrackingList,
  isConsignmentTrackLoading: state => state.isConsignmentTrackLoading,
  isApprovalDataLoading: state => state.isApprovalDataLoading,
  // details for HACH
  cartonTableData: state => state.order && state.order.package_details,

  deliverySummary: state => state.deliverySummary,
  subDeliveryPage: state => state.subDeliveryPage,
  isSubDeliveryLoading: state => state.isSubDeliveryLoading,
  subDeliveryDetails: state => state.subDeliveryDetails,
  hasEmptySubDeliveryList: state => state.hasEmptySubDeliveryList,
  isCartonFetchOpen: state => state.isCartonFetchOpen,

  deliveryNumberDetails: state => state.deliveryNumberDetails,
  canShowSaveGRN: state => state.canShowSaveGRN,
  userEdited: state => state.userEdited,
  warnedOnce: state => state.warnedOnce,
  invoiceDetails: state => state.invoiceDetails,
  integrationTimeLine: state => state.integrationTimeLine,
  changeTruckComments: state => state.changeTruckComments,
  reconciliation: state => state.reconciliation,
  isReconciliationLoading: state => state.isReconciliationLoading,
  returnMaterialDetails: state => state.returnMaterialDetails,
  returnMaterialWarnedOnce: state => state.returnMaterialWarnedOnce,
  unsavedComplaintsWarnedOnce: state => state.unsavedComplaintsWarnedOnce,
  hasUnsavedComplaints: state => state.hasUnsavedComplaints,
  currentDepotConfiguration: state => state.currentDepotConfiguration,
  payAnomalyData: state => state.payAnomalyData,
  payAnomalyLoading: state => state.payAnomalyLoading,
  getCourierTransporters: state => state.courierTransporters,
  tareWeight: state => state.tareWeight,
  grossWeight: state => state.grossWeight,
  indentSummary: state => state.indentSummary,
  complaints: state => state.complaints,
  isComplaintsLoading: state => state.isComplaintsLoading,
  vahanSarathiValidationsTimeline: state => state.vahanSarathiValidationsTimeline,

  // Material View
  isMaterialViewLoading: state => state.isMaterialViewLoading,
  materialViewSubView: state => state.materialViewSubView,
  materialViewData: state => state.materialViewData,
  materialViewMeta: state => state.materialViewMeta,
  expandedIndentMaterials: state => state.expandedIndentMaterials,
  lrAttachmentsMap: state => state.lrAttachmentsMap,
};

export default getters;
